// extracted by mini-css-extract-plugin
export default {"inputClass":"Search_inputClass__kL9XO"};